import { type CollectionChainType } from '../daas/v2/common/chains';

export enum WishlistType {
    //TODO - ask about the other types?
    Fantasy = 'Fantasy',
}
export interface CreateWishlistParam {
    name: string;
    isPrivate: boolean;
    wishlist_type?: WishlistType.Fantasy;
}

export interface EditWishlistParam extends CreateWishlistParam {
    wishlist_id: string;
}

export enum ItemType {
    Collection = 'Collection',
    // Trait = 'Trait',
    Token = 'Token',
}

export interface WishlistCollectionParam {
    Collection: {
        slug: string;
    };
}
export interface WishlistTokenParam {
    Token: {
        contract: string;
        token_id: string;
    };
}
export interface WishlistTraitParam {
    Trait: {
        slug: string;
        name: string;
    };
}

export type WishlistItemType = Partial<WishlistCollectionParam & WishlistTokenParam & WishlistTraitParam>;
export type WishlistItem = { item: WishlistItemType; quantity?: number; confirmed?: boolean; initial_value?: number };
export type WishlistItemPostParam = WishlistItemType & {
    quantity?: number;
    confirmed?: boolean;
    competitionId?: string;
    dynamicsOn?: boolean;
    network: CollectionChainType;
};
export interface AddToWishlistParam {
    wishlistId: string;
    value: WishlistItemPostParam;
}

export interface UseAddToWishlistParam {
    wishlistId: string;
    // slug for `Collection` and `Trait` methods
    slug?: string;
    // name for `Trait` method
    name?: string;
    // contract for `Token` method
    contract?: string;
    // token ID for `Token` method
    token_id?: string;
    // YFW entryItem for 'Collection' method

    network: CollectionChainType;
    competitionId?: string;
}

export type WishlistPostParam = WishlistItemType;

export interface WishlistItemCounts {
    total: number;
    collection_count: number;
    token_count: number;
    trait_count: number;
}

export interface WishlistAsset {
    something?: string;
}

export interface Wishlist {
    created_at: string;
    updated_at: string;
    network?: string;
    wishlist_id: string;
    item: WishlistItemType;
    asset?: WishlistAsset;
    quantity?: number;
}

export interface WishlistOwner {
    primary_yat?: string;
    twitter?: string | null;
}

export interface IWishlist {
    created_at: Date;
    updated_at: Date;
    id: string;
    name: string;
    private: boolean;
    user_id: string;
    counts: WishlistItemCounts;
    network?: string;
    slug: string;
    items: WishlistItem[];
    owner: WishlistOwner;
    follower_count: number;
    is_follower: boolean;
}

export type CreateWishlistResponse = IWishlist;

export interface WishlistPostResponse {
    created_at: Date;
    updated_at: Date;
    wishlist_id: string;
    network?: string;
}

export interface DeleteWishlistParam {
    wishlist_id: string;
}

export interface FollowWishlistParam {
    slug: string;
}
